import React, { useState, useEffect } from 'react';
import { ResolvedImg } from '../utils/imageResolver';
import fileService from '../services/fileService';
import './Hero.css';

const Hero = ({ title, subtitle, imageUrl, showButton = false, buttonText = '立即咨询', buttonLink = '/contact' }) => {
    const [resolvedSubtitle, setResolvedSubtitle] = useState(subtitle || '');

    useEffect(() => {
        if (subtitle && (subtitle.includes('file:') || subtitle.includes('{{file:'))) {
            fileService.resolveFileReferences(subtitle)
                .then(resolved => setResolvedSubtitle(resolved))
                .catch(error => {
                    console.error('Error resolving file references:', error);
                    setResolvedSubtitle(subtitle);
                });
        } else {
            setResolvedSubtitle(subtitle || '');
        }
    }, [subtitle]);

    return (
        <section className="hero">
            {/* Background image resolved via Unsplash when placeholder provided */}
            {imageUrl && (
                <ResolvedImg
                    src={imageUrl}
                    width={1200}
                    height={600}
                    text={title}
                    keywords={[subtitle]}
                    alt=""
                    className="hero-bg"
                    loading="eager"
                    decoding="async"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center'
                    }}
                />
            )}
            <div className="hero-overlay" aria-hidden="true" />
            <div className="container">
                <h1 
                    className="display-4 fw-bold"
                    dangerouslySetInnerHTML={{ __html: title || '' }}
                />
                <p 
                    className="lead"
                    dangerouslySetInnerHTML={{ __html: resolvedSubtitle }}
                />
                {showButton && (
                    <a href={buttonLink} className="btn btn-light btn-lg">{buttonText}</a>
                )}
            </div>
        </section>
    );
};

export default Hero;